import React from 'react';
import {resetOverlay} from "../../../store/tasks/actions";
import compose from "ramda/es/compose";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import styled from "styled-components";
import Button from "../../general/button";
import {authLogout} from "../../../store/auth/actions";

const OverLayer = styled.div`position: fixed; top: 0; bottom: 0; left: 0; right: 0; background-color: rgba(0,0,0,0.3); padding: 50px; z-index: 1`;
const Modal = styled.div`background-color: #fff; max-width: 500px; margin: 0 auto; padding: 30px;`;
const ModalBody = styled.div`min-height: 100px; margin: 0 5px;`;
const Close = styled.div`position: relative; top: -20px; left: 100%; font-size: 30px; font-weight: bold; text-decoration: none; color: #333; cursor: pointer;`;
const CompleteButton = styled(Button)`display: flex; align-items: center; justify-content: center; width: 100%; height: auto; font-size: 14px; border-width: 2px; margin: 0 5px;`;
const ButtonGroup = styled.div`align-self: flex-end; display: flex;`;

class Overlay extends React.Component {
    constructor(props) {
        super(props);
        this.callAction = this.callAction.bind(this);
    }

    callAction(action) {
        const {resetOverlay, authLogout} = this.props;
        switch (action) {
            case 'working': {
                this.props.history.push('/dashboard/working');
                break;
            }
            case 'stock': {
                this.props.history.push('/dashboard/stock');
                break;
            }
            case 'shop': {
                this.props.history.push('/dashboard/shop');
                break;
            }
            case 'logout': {
                this.props.history.push('/');
                authLogout();
                break;
            }
            default:
        }
        return resetOverlay();
    };

    render() {
        const {overlay} = this.props;

        return (!overlay.display) ? null : (
            <OverLayer>
                <Modal>
                    <Close onClick={() => this.callAction('resetOverlay')}>&times;</Close>
                    <ModalBody>{overlay.text}</ModalBody>
                    <ButtonGroup>
                        {overlay.buttons.map((button) => {
                            return (
                                <CompleteButton key={button.name} onClick={() => this.callAction(button.action)}>
                                    <span>{button.label}</span>
                                </CompleteButton>
                            );
                        })}
                    </ButtonGroup>
                </Modal>
            </OverLayer>
        );
    }
}

export default compose(connect((state) => ({overlay: state.tasks.overlay}), {
    resetOverlay,
    authLogout
}), withRouter)(Overlay);



// WEBPACK FOOTER //
// ./src/components/dashboard/grid/overlay.js